export class ProfunnelInfo {
  allTotal: number;
  proPlus: number;
  pro: number;
  aPlus: number;
  a: number;
  b: number;
  cPlusPlus: number;
  cPlus: number;
  cc: number;
  cp: number;
  d: number;
  del: number;
}
